export const parseERPNextError = (error) => {
  // Check for server messages first
  if (error.data?._server_messages) {
    try {
      const serverMessages = JSON.parse(error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const firstMessage = JSON.parse(serverMessages[0]);
        return cleanErrorMessage(firstMessage.message || "An error occurred");
      }
    } catch {
      // Continue to other methods if parsing fails
    }
  }
  
  // Try to extract from exception
  if (error.data?.exception) {
    const exceptionStr = error.data.exception;
    
    // Pattern to match the actual error message (the part after ValidationError:)
    const patterns = [
      /ValidationError:\s*(.+?)(?=\\n|$)/, // Match ValidationError messages
      /Exception:\s*(.+?)(?=\\n|$)/, // Match other exceptions
      /Error:\s*(.+?)(?=\\n|$)/ // Generic error match
    ];
    
    for (const pattern of patterns) {
      const match = exceptionStr.match(pattern);
      if (match && match[1]) {
        return cleanErrorMessage(match[1].trim());
      }
    }
    
    // If no pattern matches, clean and return the whole exception
    return cleanErrorMessage(exceptionStr);
  }
  
  // Return generic error messages
  return cleanErrorMessage(error.data?.message || error.message || "An error occurred");
};

const cleanErrorMessage = (message) => {
  if (!message) return message;
  
  // Remove HTML tags like <strong>, </strong>, <b>, </b>, etc.
  let cleaned = message.replace(/<\/?strong>/gi, '').replace(/<\/?b>/gi, '');
  
  // Remove "Row X: " pattern (Row 1:, Row 2:, etc.)
  cleaned = cleaned.replace(/^Row\s+\d+:\s*/i, '');
  
  // Remove other common prefixes
  cleaned = cleaned.replace(/^Error:\s*/i, '');
  cleaned = cleaned.replace(/^ValidationError:\s*/i, '');
  cleaned = cleaned.replace(/^Exception:\s*/i, '');
  
  // Trim any extra whitespace
  cleaned = cleaned.trim();
  
  return cleaned;
};

